const data = {
    NAME: "Contact360",
    ROOT_API: "https://vuephonebook.herokuapp.com/api",

};

module.exports = data;